document.addEventListener('DOMContentLoaded', function() {
  const triggers = document.querySelectorAll('[data-popup-trigger-block]');
  
  triggers.forEach(function(trigger) {
    const blockId = trigger.getAttribute('data-popup-trigger-block');
    const overlay = document.querySelector('.info-popup-overlay-' + blockId);
    const panel = document.querySelector('.info-popup-panel-' + blockId);
    const closeBtn = document.querySelector('[data-popup-close-block="' + blockId + '"]');

    if (!overlay || !panel) return;

    // Abrir popup
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.add('popup-open');
      
      // 1. Primero, mostrar elementos (quitar display: none)
      overlay.style.display = 'block';
      panel.style.display = 'block';
      
      // 2. Forzar reflow para que el navegador registre el cambio
      overlay.offsetHeight;
      
      // 3. LUEGO agregar clase active para activar transición
      requestAnimationFrame(function() {
        overlay.removeAttribute('style');
        panel.removeAttribute('style');
        overlay.classList.add('active');
        panel.classList.add('active');
      });
    });

    // Cerrar popup
    function closePopup() {
      panel.classList.remove('active');
      
      setTimeout(function() {
        overlay.classList.remove('active');
        
        setTimeout(function() {
          document.body.classList.remove('popup-open');
          
          // Restaurar estilos inline para prevenir FOUC
          overlay.setAttribute('style', 'display: none; opacity: 0; visibility: hidden;');
          panel.setAttribute('style', 'position: fixed; right: -700px; display: none;');
        }, 400);
      }, 400);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.classList.contains('active')) {
        closePopup();
      }
    });
  });
});